<template>
    <div>
        <h3>{{$t('message.library')}}</h3>
        <academy :type=2></academy>
        
    </div>

</template>

<script>
import Academy from '@/components/academy'; 
export default {
  name: 'acad_webinars',
  data () {
        return {
            
        }
  },
  methods:{
     
  },
  components:{
    Academy
  },
  mounted() {
      
  },
}

</script>



	